/**
 * Hooks to access markets context
 */

import { useContext } from 'react';
import { MarketsContext } from './markets-provider';
import { debug } from '@/lib/debug';

const CACHE_KEY = 'nordex_markets_cache';

export function useMarkets() {
  const context = useContext(MarketsContext);
  if (!context) {
    throw new Error('useMarkets must be used within MarketsProvider');
  }
  return context;
}

// Utility hooks
export function useMarket(symbol: string | undefined) {
  const { markets } = useMarkets();
  return markets.find(m => m.symbol === symbol);
}

export function useProduct(symbol: string | undefined) {
  const { products } = useMarkets();
  return products.find(p => p.id === symbol);
}

// Helper to get Binance symbol for a market
export function useBinanceSymbol(symbol: string | undefined) {
  const { markets } = useMarkets();
  const market = markets.find(m => m.symbol === symbol);
  return market?.binanceSymbol;
}

// Helper to invalidate cache (call after admin adds/removes markets)
export function invalidateMarketsCache() {
  localStorage.removeItem(CACHE_KEY);
  debug.log('Markets', 'Cache invalidated');
}

